import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Mandate from './mandate';
import MandateDetail from './mandate-detail';
import MandateUpdate from './mandate-update';
import MandateDeleteDialog from './mandate-delete-dialog';

const MandateRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Mandate />} />
    <Route path="new" element={<MandateUpdate />} />
    <Route path=":id">
      <Route index element={<MandateDetail />} />
      <Route path="edit" element={<MandateUpdate />} />
      <Route path="delete" element={<MandateDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default MandateRoutes;
